import React, { useEffect, useRef } from "react";
import "./contact.css";
import {
  FaEnvelope,
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaArrowRight,
} from "react-icons/fa";
import { contact } from "../../utils";

const Contact = () => {
  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const formContainerRef = useRef(null);
  const cardsRef = useRef(null);
  const formRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headingRef.current) observer.observe(headingRef.current);
    if (formContainerRef.current) observer.observe(formContainerRef.current);
    if (cardsRef.current) observer.observe(cardsRef.current);

    return () => {
      if (headingRef.current) observer.unobserve(headingRef.current);
      if (formContainerRef.current)
        observer.unobserve(formContainerRef.current);
      if (cardsRef.current) observer.unobserve(cardsRef.current);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);
    formData.append("_captcha", "false");
    formData.append("_template", "table");

    try {
      const response = await fetch(
        "https://formsubmit.co/33cf485db2ea8dc55b30eaaefd8a1eb6",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        alert("✅ Message sent successfully!");
        formRef.current.reset();
      } else {
        alert("❌ Failed to send message. Please send to my email directly.");
      }
    } catch (error) {
      alert("❌ Failed to send message. Please send to my email directly.");
    }
  };

  return (
    <section id="contact" className="contact" ref={sectionRef}>
      <div className="contact-background">
        <div className="bg-gradient"></div>
        <div className="bg-grid"></div>
        <div className="bg-dots"></div>
      </div>

      <div className="contact-container">
        <div className="contact-header" ref={headingRef}>
          <h2 className="contact-title">Let's Build Your Project Together</h2>
          <p className="contact-subtitle">
            Have a project in mind? Let's collaborate and bring your vision to
            life.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-form-container" ref={formContainerRef}>
            <div className="form-blur-overlay">
              <div className="coming-soon-badge">
                <span>Coming Soon</span>
              </div>
            </div>
            <form
              className="contact-form blurred"
              onSubmit={handleSubmit}
              ref={formRef}
            >
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Name"
                  required
                  disabled
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  disabled
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="Subject"
                  required
                  disabled
                />
              </div>

              <div className="form-group full-width">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  placeholder="Your Message"
                  required
                  disabled
                ></textarea>
              </div>

              <div className="form-group full-width">
                <div className="button-wrapper">
                  <button type="submit" className="submit-button" disabled>
                    <span>Send Message</span>
                    <FaArrowRight className="button-icon" />
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="contact-cards" ref={cardsRef}>
            <div className="contact-card">
              <div className="card-icon">
                <FaEnvelope />
              </div>
              <h3>Email</h3>
              <p>Feel free to reach out anytime</p>
              <a href={contact.email.link} target="_blank">
                {contact.email.title}
              </a>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <FaGithub />
              </div>
              <h3>GitHub</h3>
              <p>Check out my repositories</p>
              <a href={contact.github.link} target="_blank">
                {contact.github.title}
              </a>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <FaLinkedin />
              </div>
              <h3>LinkedIn</h3>
              <p>Let's connect professionally</p>
              <a href={contact.linked_in.link} target="_blank">
                {contact.linked_in.title}
              </a>
            </div>

            <div className="contact-card">
              <div className="card-icon">
                <FaTwitter />
              </div>
              <h3>Twitter</h3>
              <p>Follow me for updates</p>
              <a
                href={contact.twitter.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {contact.twitter.title}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
